// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logistic-dialog-waiting .logistic-dialog {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  text-align: center;\n  margin-bottom: 18px;\n}\n.logistic-dialog-waiting .logistic-dialog .sysnc-img {\n    display: inline-block;\n    width: 300px;\n    height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
